import React from "react";
import { Link, useLocation } from "react-router-dom";

const Customs = () => {
  const location = useLocation();


  const renderNavItem = (to, label, iconClass) => {
    const isActive = location.pathname === to;

    return (
      <li
        className={`kt-menu__item ${isActive ? "kt-menu__item--active" : ""}`}

        key={to}
      >
        <Link className="kt-menu__link" to={to}>
          <i className={`kt-menu__link-icon ${iconClass}`}></i>
          <span className="kt-menu__link-text">{label}</span>
        </Link>
      </li>
    );
  };

  return (
    <>
      {renderNavItem(
        "/customsreport/pemasukan",
        "Laporan Pemasukan Barang",
        " flaticon-folder-2 "
      )}

      {renderNavItem(
        "/customsreport/pengeluaran",
        "Laporan Pengeluaran Barang",
        "flaticon-list-1 "
      )}

      {renderNavItem(
        "/customsreport/stok",
        "Laporan Stok Barang",
        "flaticon-folder-3 "
      )}

      {renderNavItem(
        "/customsreport/mutasi",
        "Laporan Mutasi Barang",
        "flaticon-diagram "
      )}
    </>
  );
};

export default Customs;
